import { Controller } from "@hotwired/stimulus"
import Chartkick from "chartkick"

export default class extends Controller {
  static values = { url: String }
  static targets = [
    "present", "absent", "late", "authorizedAbsent", "percentage", "chartContainer", "viewReportBtn"
  ]

  connect() {
    fetch(this.urlValue)
      .then(response => {
        if (!response.ok) {
          // Handle HTTP errors like 422
          return null;
        }
        return response.json();
      })
      .then(data => {
        if (!data || Object.keys(data).length === 0) {
          this.element.classList.add('d-none')
          return;
        }

        this.render(data);
      })
      .catch(error => {
        console.warn("Attendance chart fetch failed:", error);
        this.chartContainerTarget.innerHTML = `<div class="text-center text-muted">Error loading data</div>`;
      });
  }

  render(data) {
    this.presentTarget.textContent = data.Present
    this.absentTarget.textContent = data.Absent
    this.lateTarget.textContent = data.Late
    this.authorizedAbsentTarget.textContent = data["Authorized Absent"]
    this.percentageTarget.textContent = `${data["Attendance Percentage"].toFixed(2)}%`
    this.viewReportBtnTarget.classList.remove("d-none")

    // Remove the percentage key from chart data
    const { "Attendance Percentage": _, ...chartData } = data

      new Chartkick.PieChart(this.chartContainerTarget, chartData, {
      height: "200px",
      colors: ["#4CAF50", "#F44336", "#FFC107", "#2196F3"],
      download: true
    });
  }
}
